// Quick action deep-links for the 3 RFID / iButton scan-alert event types.
export const SCAN_ALERT_TYPES = ['unmatched_rfid_scan', 'unallocated_rfid_scan', 'disabled_rfid_scan'];

export function scanAlertQuickAction(eventType, credential) {
  if (!credential || !SCAN_ALERT_TYPES.includes(eventType)) return null;
  const cred = encodeURIComponent(credential);
  if (eventType === 'unmatched_rfid_scan') {
    return { label: 'Assign this card', url: `/people?tab=rfid-cards&assign_card=${cred}`, kind: 'card' };
  }
  if (eventType === 'unallocated_rfid_scan') {
    return { label: 'Allocate this card', url: `/people?tab=rfid-cards&search=${cred}`, kind: 'card' };
  }
  return { label: 'View this card', url: `/people?tab=rfid-cards&search=${cred}`, kind: 'card' };
}

// Deep-link to a person's profile drawer (Documents section) — used by document expiry alerts.
export function personOpenAction(eventType, personType, personId) {
  if (eventType !== 'document_expiry' || !personType || !personId) return null;
  const tab = personType === 'staff' ? 'staff' : `${personType}s`;
  return { label: 'Open person', url: `/people?tab=${tab}&open_person=${personType}:${encodeURIComponent(personId)}`, kind: 'person' };
}
